import * as React from 'react'

import { Text } from '@factorialco/deprecated-design-system'
import { FeatureFlagAvailabilitiesDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import CollectionsBootstrap from 'modules/employees/lib/SettingsCollectionsBootstrap'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import CompanyIdentifierSettings from './CompanyIdentifierSettings'
import DefaultEndDate from './DefaultEndDate'

const Container = () => {
  const { company } = useCurrentSession()
  const { data: featureData, loading: featureLoading } = useQuery(
    FeatureFlagAvailabilitiesDocument,
    {
      variables: {
        companyId: company.id,
        featureNames: ['auto_generate_employee_company_identifier'],
      },
    }
  )

  const isCompanyIdentifierFeatureEnabled = featureData?.features?.featuresConnection?.nodes?.find(
    (feature) => feature.name === 'auto_generate_employee_company_identifier'
  )?.enabled

  return (
    <ResponsivePage.Body showHeader={false}>
      {featureLoading ? (
        <Text.Normal>{i18n.t('common.loading')}</Text.Normal>
      ) : (
        <>
          <DefaultEndDate />
          {isCompanyIdentifierFeatureEnabled && (
            <CompanyIdentifierSettings companyId={company.id} />
          )}
        </>
      )}
    </ResponsivePage.Body>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
